function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDynamicPackageFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 13.196h2v13h-2v-11H18v6.287l-2-1.131v-7.156h2v-1.5h10v1.5zm-6 8h-2v-1.5h2v1.5zm4 0h-2v-1.5h2v1.5zm-4-3h-2v-1.5h2v1.5zm4 0h-2v-1.5h2v1.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.945 21H2v-2h5.945a9 9 0 014.337 1.114l7.06 3.883A3.2 3.2 0 0117.801 30H2v-2h15.8a1.2 1.2 0 00.579-2.25l-7.06-3.884A7 7 0 007.945 21z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M2 23h2v2H2zM5.5 23h2v2h-2zM9.5 23h5l3 2H12l-2.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.167 2.285a1.062 1.062 0 011.16-.2l5.741 2.54 3.521-1.532a3.518 3.518 0 014.71 2.023 2.7 2.7 0 01-1.613 3.46L6.178 14.22a1.062 1.062 0 01-1.279-.46L2.161 9.106a1.062 1.062 0 011.167-1.57l3.381.823 1.7-.714L9.635 9.29 7.21 10.452c-.21.088-.442.107-.662.053l-1.281-.312 1.016 1.729L20.96 6.579a.575.575 0 00.344-.737 1.394 1.394 0 00-1.866-.8L15.49 6.76a1.062 1.062 0 01-.854-.003l-4.464-1.975 2.439 3.286-1.993.797-3.35-4.444A1.062 1.062 0 017.39 3.02l.776-.735z",
    fill: props.color
  }));
}

export default SvgIconDynamicPackageFilled;